import React from "react";
import { eventsData } from "../data/eventsData";
import PageTransition from "../components/PageTransition";

const Events = () => {
  const parseEventDate = (event) => {
    const year = event.id.split("-")[0];
    const cleanedDateStr = event.date.split(",")[0] + `, ${year}`;
    return new Date(cleanedDateStr);
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const upcomingEvents = eventsData
    .filter((event) => parseEventDate(event) >= today)
    .sort((a, b) => parseEventDate(a) - parseEventDate(b));

  return (
    <PageTransition>
      <div className="container mx-auto px-4 md:px-[5rem] py-8 md:py-16">
        <h1 className="text-[32px] md:text-[43.2px] text-[#6B492A] font-[700] tracking-[2px] md:tracking-[6px] font-['Domine'] uppercase text-center mb-8 md:mb-16">
          Events
        </h1>
        {upcomingEvents.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {upcomingEvents.map((event) => (
              <div key={event.id} className="group">
                {event.image && (
                  <div className="overflow-hidden aspect-[4/3] bg-black">
                    <img
                      src={event.image}
                      alt={event.title}
                      className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                )}
                <h2 className="text-[2rem] tracking-[3px] font-[600] font-['Domine'] text-[#6B492A] mt-4 leading-tight text-center">
                  {event.title}
                </h2>
                {event.genre && (
                  <p className="text-[#6B492A] text-sm md:text-base opacity-75 mt-1 tracking-wide text-center italic">
                    {event.genre}
                  </p>
                )}
                <p className="text-[#6B492A] text-base md:text-lg opacity-80 mt-2 font-medium tracking-wide text-center">
                  {event.date} &nbsp;·&nbsp; {event.time}
                </p>
                {event.description && (
                  <p className="text-[#6B492A] text-sm opacity-70 mt-1 tracking-wide text-center italic">
                    {event.description}
                  </p>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-[#6B492A] opacity-60 tracking-widest uppercase text-sm">
            More events coming soon
          </p>
        )}
      </div>
    </PageTransition>
  );
};

export default Events;
